import { render, staticRenderFns } from "./delayDialog.vue?vue&type=template&id=6a379090&lang=pug&"
import script from "./delayDialog.vue?vue&type=script&lang=js&"
export * from "./delayDialog.vue?vue&type=script&lang=js&"
import style0 from "./delayDialog.vue?vue&type=style&index=0&id=6a379090&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports